import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress } from '@material-ui/core';

class MainForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
          warning: '',
          showError: false,
      }
    }

    componentDidMount = () => {

      // console.log('this.props.fname_passthrough :>> ', this.props.fname_passthrough);

      //fetch final user object
      GServ.fetch_final_obj(this.props.form_token)
      .then(final_obj => {
        // console.log('final_obj :>> ', final_obj);

        if (final_obj.Result !== "Found"){
          //Error handling here...
          console.log('final_obj :>> ', final_obj);
          this.setState({showError:true,warning:"Unfortunately a technical error has been encountered. If this problem persists, please contact us."});

        } else {

          const nationality = final_obj.unique_id_type==='said'? "South African" : final_obj.unique_id_nationality;
          const id_type = final_obj.unique_id_type==='said' ? "SA Identity Number" : (final_obj.unique_id_type==='fid' ? "Foreign National Identity Numnber" : "Foreign Passport Number");
          const dob = final_obj.date_of_birth.substring(0,10);
        
          const url = this.props.form_url + '?entry={"Token":"' + this.props.form_token + '","EmailPassthrough":"' + final_obj.contact_email + '","MobilePassthrough":"' + final_obj.contact_mobile + '","FnamesConfirmed":"' + final_obj.first_name.toUpperCase() + '","LnameConfirmed":"' + final_obj.last_name.toUpperCase() + '","PayGate":"' + this.props.paygate + '","AutoRegister":"' + this.props.auto_register + '","PaygateItem":"' + this.props.paygate_item + '","PaygateAmount":"' + this.props.paygate_amount + '","SaCitizen":"'+ final_obj.sa_citizen + '","Gender":"' + final_obj.gender + '","UniqueId":"' + final_obj.unique_id + '","UniqueIdType":"' + id_type + '","UniqueIdNationality":"' + nationality + '","DateOfBirth":"' + dob + '"}';
        
          // console.log('this.props :>> ', this.props);
          // console.log('nationality :>> ', nationality);
          // console.log('id_type :>> ', id_type);
          // console.log('url :>> ', url);
          window.location.href = encodeURI(url);

        }
      });
    };
    
    render() {
        return (
            <div>
                {!this.state.showError&&
                <p>
                  <CircularProgress size={30} />  Generating {this.props.form_title}...
                </p>}
                
                {this.state.showError&&
                <div>
                  <span className='warningMessage'>{this.state.warning}</span>
                  <p>
                      <a href={'mailto:' + this.props.info_email}>{this.props.info_email}</a>
                      <br/><br/>
                      {this.props.contact_phone}
                  </p>
                </div>}
           
            </div>
        );
    }

}

export default MainForm;